import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconChatComponent } from "./med-icon-chat.component";

@NgModule({
  declarations: [
    MedIconChatComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconChatComponent,
  ],
})
export class MedIconChatModule { }
